import React, { lazy, useEffect } from 'react';
import { RoutePaths } from '@core/routes/routeConfig';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLogin } from '@stores/auth/selectors.js';

const NonAuthVerticalLayout = lazy(
  () => import('@components/layouts/VerticalLayout/NonAuthVerticalLayout'),
);

function NonAuthLayout({ component: Component }) {
  const navigate = useNavigate();
  const isLogin = useSelector(selectLogin);

  useEffect(() => {
    if (isLogin) navigate(RoutePaths.AUTH);
  }, [isLogin]);

  return (
    <NonAuthVerticalLayout>
      <Component />
    </NonAuthVerticalLayout>
  );
}

export default NonAuthLayout;
